__turbopack_context__.v({
  "count": "styles-module-scss-module__83yXsq__count",
  "max": "styles-module-scss-module__83yXsq__max",
  "primary": "styles-module-scss-module__83yXsq__primary",
  "progress": "styles-module-scss-module__83yXsq__progress",
  "root": "styles-module-scss-module__83yXsq__root",
});
